import { DateTime, Duration } from "luxon";

import type { UserId } from "@core/domains/identity";
import type { Stage } from "@core/foundation/stage";
import type { JwtSignerContract } from "@core/ports/signing";

import type { UserRole, UserScope } from "../../models/index.ts";
import { UserClaimsSchema } from "../../models/index.ts";

const USER_TOKEN_LIFETIME = Duration.fromObject({ days: 30 });

export class UserJwtSigner {
  private readonly signer: JwtSignerContract;

  private readonly stage: Stage;

  public constructor({
    signer,
    stage,
  }: { readonly signer: JwtSignerContract; readonly stage: Stage }) {
    this.signer = signer;
    this.stage = stage;
  }

  public async sign({
    role,
    scopes,
    userId,
  }: {
    readonly role: UserRole;
    readonly scopes: readonly UserScope[];
    readonly userId: UserId;
  }): Promise<string> {
    const utcNow = DateTime.utc();
    const now = Math.floor(utcNow.toSeconds());
    const exp = Math.floor(utcNow.plus(USER_TOKEN_LIFETIME).toSeconds());
    const payload = UserClaimsSchema.decode({
      exp,
      iat: now,
      id: userId,
      role,
      scopes,
      stage: this.stage,
      type: "user",
      version: 1,
    });

    return this.signer.sign(payload);
  }
}
